import { useIsArtefactEditable } from '@modules/common/hooks';
import { Direction } from '@modules/common/types';
import { DashboardAddContentMenu } from '@modules/dashboard/components/DashboardAddContentMenu';
import { useDashboardStore } from '@modules/dashboard/store/useDashboardStore';
import { AddRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';

interface DashboardHeaderAddAnalysisButtonProps {
  setIsHovered?: (value: boolean) => void;
}

export const DashboardHeaderAddAnalysisButton = ({
  setIsHovered,
}: DashboardHeaderAddAnalysisButtonProps) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(menuAnchor);
  const dashboard = useDashboardStore(({ dashboard }) => dashboard);

  const isEditable = useIsArtefactEditable({
    editToken: dashboard.editToken,
    status: dashboard.status,
  });

  if (!dashboard || (!isEditable && dashboard.id)) {
    return null;
  }

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const closeMenu = () => {
    setMenuAnchor(null);
    setIsHovered && setIsHovered(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={openMenu}
        startIcon={<AddRounded />}
        onMouseEnter={() => setIsHovered && setIsHovered(true)}
        onMouseLeave={() => isMenuOpen || (setIsHovered && setIsHovered(false))}
      >
        Add
      </Button>
      <DashboardAddContentMenu
        isOpen={isMenuOpen}
        anchorEl={menuAnchor}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        shouldShowNewOptions={true}
        cellInsertDirection={Direction.Bottom}
      />
    </>
  );
};
